import React, { useEffect, Suspense, lazy } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
    setSubtitleList,
    setChangedSubtitle,
    setSelectedSubtitle,
    setChangedTimelineSubtitle
} from '@modules/subtitle';

import {
    setVodInfo,
    setPlayTime,
    setSelectedPlayTime,
} from '@modules/media';

import LoadingComponent from '@components/_commons/LoadingComponent';
import CustomTabPanel from '@components/_commons/TabPanel';

import api from '@utils/axiosInstance';
import VideoInfo from '@components/services/csmsmedia/vodManage/videoInfo/VideoInfoTab';
import InfoCard from '@components/services/csmsmedia/vodManage/infoCard/InfoCardTab';
import SubtitleTab from '@components/services/csmsmedia/vodManage/subtitle/SubtitleTab';
import ChapterTab from '@components/services/csmsmedia/vodManage/chapter/ChapterTab';
import EditorTab from '@components/services/csmsmedia/vodManage/editor/EditorTab';

function VideoDetailContainer({ }) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { uuid } = useParams();
    const { t } = useTranslation();

    const userToken = useSelector((state: any) => state.organization.userToken);
    const organizationData = useSelector((state: any) => state.organization.organizationData);

    // ✅ 탭 index를 URL에서 실시간 계산
    const getTabIndexFromPath = (path: string): number => {
        if (path.includes('/subtitle')) return 1;
        if (path.includes('/chapter')) return 2;
        if (path.includes('/editor')) return 3;
        if (path.includes('/infocard')) return 4;
        return 0;
    };

    const tabIndex = getTabIndexFromPath(location.pathname);

    const handleTabChange = (event: any, newValue: number) => {
        switch (newValue) {
            case 0:
                navigate(`/vod/${uuid}`);
                break;
            case 1:
                navigate(`/vod/${uuid}/subtitle`);
                break;
            case 2:
                navigate(`/vod/${uuid}/chapter`);
                break;
            case 3:
                navigate(`/vod/${uuid}/editor`);
                break;
            case 4:
                navigate(`/vod/${uuid}/infocard`);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        dispatch(setPlayTime(0));
        dispatch(setSelectedPlayTime(0));
        dispatch(setChangedSubtitle({}));
        dispatch(setChangedTimelineSubtitle({}));
        dispatch(setSubtitleList({}));
        dispatch(setSelectedSubtitle({}));

        api({
            method: 'post',
            url: '/csmsmedia/video/getVideoInfo',
            data: {
                uuid
            }
        })
            .then((response) => {
                if (response.data.code === 100) {
                    dispatch(setVodInfo(response.data.data));
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    return (
        <div className='container-video-tabs'>
            <div className="container-video-wrapper">
                <Box className="video-tabs-border-box">
                    <Tabs value={tabIndex} onChange={handleTabChange} style={{ padding: '0 20px' }}>
                        <Tab className="video-tab" label={t('vod.manage.video_info')} />
                        <Tab className="video-tab" label={t('vod.manage.subtitle')} />
                        <Tab className="video-tab" label={t('vod.manage.chapter')} />
                        <Tab className="video-tab" label={t('vod.manage.editor')} />
                        {/* <Tab className="video-tab" label="InfoCard" /> */}
                    </Tabs>
                </Box>

                <CustomTabPanel value={tabIndex} index={0}>
                    <Suspense fallback={<LoadingComponent />}>
                        <VideoInfo />
                    </Suspense>
                </CustomTabPanel>

                <CustomTabPanel value={tabIndex} index={1} className="tab-panel-full-height">
                    <Suspense fallback={<LoadingComponent />}>
                        <SubtitleTab />
                    </Suspense>
                </CustomTabPanel>

                <CustomTabPanel value={tabIndex} index={2} className="tab-panel-full-height">
                    <Suspense fallback={<LoadingComponent />}>
                        <ChapterTab />
                    </Suspense>
                </CustomTabPanel>

                <CustomTabPanel value={tabIndex} index={3} className="tab-panel-full-height">
                    <Suspense fallback={<LoadingComponent />}>
                        <EditorTab />
                    </Suspense>
                </CustomTabPanel>
            </div>
        </div>
    );
}

export default VideoDetailContainer;